<template>
  <div class="phoneSheetVue">
    <div v-if="job">
        <div class="o-main-content-area o-main-content-area--padBotoomNone">
            <div class="row c-responsive-fixwidth">
                <div class="col-md-6">
                    <h1 class="h1">Jobs / Events:<a href="javascript: void(0)" @click="backToJobDetails">{{" " + title}}</a></h1>
                </div>
                <div class="col-md-6 text-right">
                    <div class="phonesheet-time-out">
                        <label><span class="o-blue-regular-text">Global Call Timer:</span></label>
                        <select class="phone-sheet-call-timeout-disable" placeholder="Days" v-model="globalTimeOut.days" disabled>
                            <option v-for="(day,dayIdx) in selectConfig.days" :key="dayIdx" :value="day">{{'0'+day}} 
                            </option>
                        </select> :
                        <select class="phone-sheet-call-timeout-disable" placeholder="Hours" v-model="globalTimeOut.hours" disabled >
                            <option v-for="(hour,hourIdx) in selectConfig.hours" :key="hourIdx" :value="hour">{{hour>=10?hour:'0'+hour}} 
                            </option>
                        </select> :
                        <select class="phone-sheet-call-timeout-disable" placeholder="Minuts" v-model="globalTimeOut.mins" disabled>
                            <option v-for="(min,minIdx) in selectConfig.mins" :key="minIdx" :value="min">{{min>=10?min:'0'+min}} 
                            </option>
                        </select>
                    </div> 
                    <div class="phonesheet-time-out">
                        <label><span class="o-blue-regular-text">Job Call Timer:</span></label>
                        <select 
                        @change="onChangeJobTimeOut()" 
                        class="phone-sheet-call-timeout" 
                        placeholder="Days" 
                        v-model="jobTimeOut.days" 
                        :disabled="!getPower('callTimer')">
                            <option value='' disabled>Days</option>
                            <option v-for="(day,dayIdx) in selectConfig.days" :key="dayIdx" :value="day">{{'0'+day}} 
                            </option>
                        </select> :
                        <select 
                        @change="onChangeJobTimeOut()" 
                        class="phone-sheet-call-timeout" 
                        placeholder="Hours" 
                        v-model="jobTimeOut.hours" 
                        :disabled="!getPower('callTimer')">
                            <option value='' disabled>Hours</option>
                            <option v-for="(hour,hourIdx) in selectConfig.hours" :key="hourIdx" :value="hour">
                                {{hour>=10?hour:'0'+hour}} 
                            </option>
                        </select> :
                        <select 
                        @change="onChangeJobTimeOut()" 
                        class="phone-sheet-call-timeout" 
                        placeholder="Minutes" 
                        v-model="jobTimeOut.mins" 
                        :disabled="!getPower('callTimer')">
                            <option value='' disabled>Minutes</option>
                            <option v-for="(min,minIdx) in selectConfig.mins" :key="minIdx" :value="min">
                                {{min>=10?min:'0'+min}} 
                            </option>
                        </select>
                    </div>

                    <div class="w-75 ml-auto">
                        <label class="common-label-text">Select Autofill Metric:</label>
                        <label class="common-label-input">
                            <select @change="onChangeAutofillMetrics()" v-model="autofillMetrics" id="select-metric" class="form-control select_margin_adjust">
                                <option value=''>Select</option>                            
                                <option v-for="(metric, index) in metrics" :value="metric.value" :key="index">{{ metric.name }}</option>
                            </select>
                        </label>
                    </div>

                    <div class="margin-10">
                        <label><span class="o-blue-regular-text">Autofill On/Off:</span></label>
                        <el-switch
                            style="display: inline"
                            v-model="autofill_status"
                            @change="onChangeAutofillStatus()"
                            active-color="#13ce66"
                            inactive-color="#dcdfe6"
                            :active-value="1"
                            :inactive-value="0">
                        </el-switch>
                    </div>

                    <open-window-panel
                        v-if="false && job && job.id"
                        :job-id="job.id"
                        :user-token="userToken"
                        :client-id="userClientID"
                    />
                </div>
            </div>

            <div class="c-common-space c-responsive-fixwidth">
                <div class="col-md-12 o-tab-area o-no-padding">
                    <ul class="o-tab-view o-tab-view--text">
                        <li @click="goToViewCalls()"><a href="javascript: void(0)" class="call-deactive">Calls</a></li>
                        <li @click="goToPhoneSheet()"><a href="javascript: void(0)" class="active">PhoneSheet</a></li>
                        <li @click="backToJobDetails()"><a href="javascript: void(0)" class="call-deactive">Job Details</a></li>
                        <li @click="gotoJobAttendance()"><a href="javascript: void(0)" class="call-deactive">Attendance</a></li>
                        <li @click="loadWishlistSummaryReportJson()"><a href="javascript: void(0)" class="call-deactive">Wishlist Summary</a></li>
                        <li @click="loadWishlistSummary30DayReportJson()"><a href="javascript: void(0)" class="call-deactive">WishList 30 Day</a></li>
                    </ul>
                </div>
            </div>
           
            <div class="c-common-space c-common-space--overflowVisible clearfix c-responsive-fixwidth">
                <div class="col-md-12 o-no-padding">
                    <div class="custom-row">
                        <div class="col-md-9 o-no-padding">
                            <div class="custom-col text-left">
                                <div class="o-viewBy">
                                    <label>
                                        <span class="o-blue-regular-text">Steward:</span> 
                                        {{(job&& job.employee && job.employee.employable) ? 
                                        job.employee.employable.first_name+" "+job.employee.employable.last_name : 
                                        "NA"}}
                                    </label>
                                </div>
                            </div>
                            <div class="custom-col text-left">
                                <div class="o-viewBy">
                                    <label>
                                        <span class="o-blue-regular-text">Employer:</span> 
                                        {{(job && job.employer) ? job.employer.name : "NA"}}
                                    </label>
                                </div>
                            </div>
                            <div class="custom-col text-left">
                                <div class="o-viewBy">
                                    <label @click="openMap()" role="button">
                                        <span class="o-blue-regular-text">Venue:</span> 
                                        {{(job && job.venue) ? job.venue.name : "--"}}
                                    </label>
                                </div>
                            </div>
                            <div class="custom-col text-left">
                                <div class="o-viewBy">
                                    <label><span class="o-blue-regular-text">HTS:</span> {{job && job.hts_flag?'Yes':'No'}}</label>
                                </div>
                            </div>
                            <div class="custom-col text-center">
                                <form class="form-inline">
                                    <div class="form-group o-customSelect">
                                        <label class="o-blue-regular-text">Date:</label>
                                        <div class="o-custom-dropdown o-inline-block">
                                            <select @change="onSelectScrollTo($event)" class="form-control">
                                                <option 
                                                    v-for="(phoneSheet, key, index) in phoneSheetList" :key="index" 
                                                    v-if="phoneSheet && phoneSheet.length>0" 
                                                    :value="'#element'+index">
                                                    {{getGlobalDate(key)}}
                                                </option>
                                            </select>
                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                    <div class="form-group o-customSelect">
                                        <label for="" class="o-blue-regular-text">Sort By</label>
                                        <div class="o-custom-dropdown o-inline-block">
                                            <select v-model="selectedShortType" @change="sortPhoneSheet()" class="form-control">
                                            <option value="fname_asc">FirstLast (Employee name)</option>
                                            <option value="lname_asc">LastFirst (Employee name)</option>
                                            <option value="seniority">Seniority</option>
                                            <option value="skill">Skill</option>
                                            </select>
                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-md-3 o-no-padding text-right">
                            <ul class="o-float-link">
                                <li v-if="getPower('batchNotify')&&displayBatchNotify">
                                    <a href="javascript: void(0)" @click="addBatchNotify('batch')">
                                        <i class="fa fa-file-text" aria-hidden="true"></i> 
                                        Batch Notify
                                    </a>                                
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="gotoNotifyLog()">
                                        <i class="fa fa-envelope-o" aria-hidden="true"></i> 
                                        Notify Log
                                    </a>
                                </li>
                                <li><a href="javascript: void(0)" 
                                    @click="gotoActionlog()">
                                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> 
                                    Action Log
                                </a>
                            </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-loading="loading" class="o-ndividualArea c-responsive-fixwidth"> 
            <div v-for="(phoneSheet, key, index) in phoneSheetList" :key="key" 
            v-if="phoneSheet && phoneSheet.length > 0" 
            class="o-ndividualTable">
                <div class="c-common-space o-individual-calls">
                    <div class="col-md-12 o-no-padding form-inline">
                        <div v-if="getPower('phoneSheetActions')" class="checkbox o-custom-radio">
                            <label v-if="dateWiseCheckField && dateWiseCheckField.length>0">
                                <input 
                                type="checkbox" 
                                name="'dateCheck'+index" 
                                v-model="dateWiseCheckField[index].dateCheck" 
                                @change="updateSubSelection(index,phoneSheet)">
                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                            </label>
                        </div>
                        <h5 :id="'element'+index" class="h5">{{getDate(key)}}</h5>
                        <div class="form-group">
                            <div class="o-customSelect" v-if="getPower('phoneSheetActions')">
                                <label>Action:</label>
                                <div class="o-custom-dropdown o-inline-block">
                                    <select v-model="dateWiseCheckField[index].selectedBulkAction" @change="onSelectAction(index)" class="form-control">
                                    <option value="">-- Select Action --</option>
                                        <option value="Confirm">Confirm</option>
                                        <option value="Pass" v-if="pass_option==1">Pass</option>
                                        <option value="Decline">Decline</option>
                                        <option value="Clear">Clear</option>
                                        <option value="Mark">Mark Called</option>
                                        <option value="Notify">Notify</option>
                                    </select>
                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-for="(phone, pos) in phoneSheet" :key="pos" class="o-custom-table-container c-common-box-shadow c-radius3" :style="phone.af ? {'border-left': '4px solid #f57c00'} : {}">
                    <div class="o-calls-table c-common-gradient phonesheet-list-table-align phonesheet-list-table--adjust">
                        <div class="calls-table-row phonesheet-table-row">
                            <div class="calls-table-cell" style="flex: 0 0 36px; max-width: 36px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 0; gap: 2px;">
                                <span v-if="phone.af" style="color: #f57c00; font-weight: 700; font-size: 13px; line-height: 1;">AF</span>
                                <span v-if="phone.af && afMetricLabel" style="color: #f57c00; font-weight: 600; font-size: 9px; line-height: 1;">{{ afMetricLabel }}</span>
                            </div>
                            <div class="calls-table-cell" :class="{'isDisabled':!getPower('phoneSheetActions')}">
                                <div class="table-td-border-right o-no-padding">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                <input 
                                                @change="onUpdateSubInput(index)" 
                                                type="checkbox" name="'check'+key" 
                                                :value="phone.id" 
                                                v-model="dateWiseCheckField[index].callUnderDate">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Start time:</span>
                                            <div>{{getTime(phone.start)}}</div>
                                        </div>
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>End time:</span>
                                            <div>{{getTime(phone.end)}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Position <i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                        <div>{{phone.skill.name}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Employee</span>
                                            <div>{{ (phone && 
                                                phone.employee && 
                                                phone.employee.employable) ? 
                                                phone.employee.employable.first_name+" "+phone.employee.employable.last_name : 
                                                '' }}
                                                <span 
                                                    v-if="phone.employee && 
                                                    phone.employee.employee_status && 
                                                    phone.employee.employee_status.block_job_notifications" 
                                                    class="o-sign-in-sheet-nb">
                                                    NB
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Status:</span>
                                            <div v-if="phone.marked_at!='' && phone.marked_at">Marked: {{getDateForStatus(phone.marked_at)}}</div>
                                            <div v-if="phone.notified_at!='' && phone.notified_at">Notified: {{getDateForStatus(phone.notified_at)}}</div>
                                            <div v-if="phone.status.name!='Marked' || phone.status.name!='Notified'">--</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Sen.</span>
                                        <div>{{( phone && 
                                        phone.employee) && 
                                        phone.employee.seniority ? 
                                        getRoundOffSkillSeniority(phone.employee.seniority) : 
                                        '' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Phone Number:</span>
                                            <div v-if="phone && phone.employee && phone.employee.employable">
                                            <div v-for="(phno,phIndex) in phone.employee.employable.phones" :key="phIndex">
                                                <div @click="markedCall(phone.id)" v-if="phno.phone_number">
                                                    <a :href="'tel:'+getClientContactFormat(phno.phone_number)" class="phone-number-display">
                                                        {{ phno.phone_number ? getClientContactFormat(phno.phone_number) : '' }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <div class="phone-sheet-list-note-value"><span>Notes:</span><br/>{{phone.notes}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell" 
                                v-if="showCustom && customField1 && showCustom != 0 && customField1 != null && customField1 != ''">
                                <div class="table-td-border-left o-left-side-padding5">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>{{customField1}}</span>
                                            <div>
                                            <div> 
                                                {{phone && phone.employee && 
                                                phone.employee.custom_field1 && 
                                                phone.employee.custom_field1 !=''? 
                                                getCustomField(phone.employee.custom_field1) : 
                                                '--' }}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell" v-if="showCustom && customField2 && showCustom != 0 && customField2 != null && customField2 != ''">
                                <div class="table-td-border-left o-left-side-padding5">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>{{customField2}}</span>
                                            <div>
                                            <div> 
                                                {{phone && phone.employee && 
                                                phone.employee.custom_field2 && 
                                                phone.employee.custom_field2 !='' ? 
                                                getCustomField(phone.employee.custom_field2) : 
                                                '--'}}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="o-table-extend-area u-pad-all-5 text-left">
                        <ul class="o-table-extend" :class="{'isDisabled':!getPower('phoneSheetActions')}">
                            <li>
                                <a href="javascript: void(0)" 
                                    @click="checkOtherBookingConflict(phone)" 
                                    class="o-confirm-icon">
                                    <i class="fa fa-check-circle" aria-hidden="true"></i> 
                                    Confirm
                                    <span class="otb-flag" 
                                        v-if="phone.mua_booking_conflict&&phone.mua_booking_conflict.length"> 
                                        OTB {{" - " + phone.mua_booking_conflict[0] }} 
                                    </span>
                                </a>
                            </li>
                            <li v-if="pass_option==1">
                                <a href="javascript: void(0)" 
                                    @click="passCall(phone.id)" 
                                    class="o-pass-icon">
                                    <i class="fa fa-share-square-o" aria-hidden="true"></i> 
                                    Pass
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" 
                                    :disabled="disabled" @click="declineCall(phone)" 
                                    class="o-decline-icon">
                                    <i class="fa fa-times" aria-hidden="true"></i> 
                                    Decline
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" 
                                    @click="clearAssign(phone.id)" 
                                    class="o-clear-icon">
                                    <i class="fa fa-trash" aria-hidden="true"></i> 
                                    Clear
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" 
                                    @click="markedCall(phone.id)" 
                                    class="o-markcalled-icon">
                                    <i class="fa fa-bookmark" aria-hidden="true"></i> 
                                    Mark Called
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" 
                                    @click="addBatchNotify(phone.id)" 
                                    class="o-notify-icon" 
                                    :class="{'isDisabled':phone.employee && 
                                    phone.employee.employee_status && 
                                    phone.employee.employee_status.block_job_notifications}">
                                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Notify
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div v-if="phoneSheetList && phoneSheetList.length == 0 && afterAPI == true" class="o-ndividualTable">
                <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                    <div class="col-md-12 no-job-dispaly" style="font-size: 20px;">
                        <i class="fa fa-frown-o" aria-hidden="true"></i>
                        <br />
                        There are currently no calls to be notified or confirmed 
                    </div>
                </div>
            </div>
        </div>

        <modal name="batch-notify"  height="auto" :scrollable="false" class="modal-dialog modal-sm">
            <div class="modal-add-newJob" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center o-small-modal-head">
                            <button 
                                @click="closeBatchNotify()" 
                                type="button" 
                                class="close custom-modal--close" 
                                data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 class="modal-title">{{notifyType =='batch'?'Batch ':'Single'}} Notify</h4>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body" v-loading.this.lock="lockNotify">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-12" v-if="notifyType =='batch'">
                                        <div class="o-margin-bottom10 o-sms-field">
                                            <label class="common-label-text common-label-text-block">Send to:</label>
                                            <div class="o-cutsomSelect">
                                                <select class="form-control" v-model="send_to">
                                                    <option value="not_notified_yet" selected>Only users who haven't been messaged yet</option>
                                                    <option value="all_unconfirmed">All unconfirmed users</option>
                                                    <option value="all">All users on this job</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="send_to!='all'" class="col-sm-12">
                                        <div class="o-margin-bottom10">
                                            <label class="common-label-text common-label-text-block">Include Call Info?:</label>
                                            <div class="o-cutsomSelect">
                                                <select class="form-control" v-model="call_info" @change="updateSmsLength()">
                                                    <option value="no">No</option>
                                                    <option value="before">Yes, before the message</option>
                                                    <option value="after">Yes, after the message</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <label class="common-label-text common-label-text-block">Message:</label>
                                        <div class="o-sms-counter">
                                            {{sms.length}}/ {{ getTotalTemplateCharCount() }}
                                        </div>
                                        <textarea 
                                            :maxlength="getTotalTemplateCharCount()"
                                            class="form-control o-margin-bottom10" 
                                            :class="{ 'error-border': error.sms && error.sms.hasError }"
                                            v-model="sms"
                                            rows="5"
                                            placeholder="Enter your message here"
                                            @input="validateContent('sms', sms)"
                                        ></textarea>

                                        <div v-if="error.sms && error.sms.hasError" class="err-msg">
                                            {{ error.sms.message }}
                                        </div>
                                        
                                        <div>
                                            <label class="common-label-text">Templates:</label>
                                            <span v-for="(msg, inx) in templateMsgs" :key="inx">
                                                <a @click="addTemplateMsgs(msg)" class="ps-message-suggestions">{{msg}}</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" 
                                        @click="closeBatchNotify()" 
                                        data-dismiss="modal" 
                                        aria-label="Close" 
                                        class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue">
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> 
                                        Cancel
                                    </a>
                                </li>
                                <li>
                                    <a :disabled="lockNotify" 
                                        href="javascript: void(0)" 
                                        size="small" 
                                        @click="sendNotify()" 
                                        :class="{'isDisabled': lockNotify}" 
                                        class="btn c-solid-btn c-solid-btn--large c-solid-btn--green">
                                        <i class="fa fa-paper-plane" aria-hidden="true"></i>
                                        Send
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="calender-details" height="auto" :scrollable="false" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
                    <div role="document">
                        <div class="modal-content o-common-modal-content">
                            <div class="modal-header text-center">
                                <button @click="closeMap()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 class="modal-title">Event : {{selectedJob.title}}</h1> </div>
                            <div class="modal-body c-common-box-shadow o-modal-body o-modal-body--calender">
                                <form>

                                <div class="row">
                                    <div class="col-sm-12 o-no-padding o-calender-container">
                                        <div class="col-md-7 o-calender-area">
                                            <div class="custom-row u-common-box-shadow c-radius3">
                                                <div class="o-calls-table">
                                                    <div class="o-common-head">
                                                        <h5 class="c-common-heading">
                                                            <i class="fa fa-map-marker" aria-hidden="true"></i> 
                                                            Venue: {{(selectedJob  && Object.keys(selectedJob).length>0)?selectedJob.venue.name+", "+selectedJob.venue.addresses[0].address + ", " + selectedJob.venue.addresses[0].state_province + ", " + selectedJob.venue.addresses[0].country:''}}</h5>
                                                    </div>
                                                    <div class="o-map-conatiner">
                                                        <iframe 
                                                            width="100%"
                                                            height="100%"
                                                            frameborder="0" style="border:0"
                                                            :src="getMapUrl()" allowfullscreen>
                                                        </iframe>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    </div>
                                </form>
                            </div>

                            <div class="modal-footer text-center">
                            </div>
                        </div>
                    </div>
            </div>
        </modal>

        <modal name="add-note-callout-decline" 
            height="auto" 
            :scrollable="false" 
            class="modal-dialog modal-sm modal--custom" 
            @closed="openCloseAddNoteModal('close', null)">
            <div tabindex="-1" role="dialog" >
                <div role="document">
                    <div class="modal-content">                    
                        <div class="modal-header text-center">
                            <button 
                                @click="openCloseAddNoteModal('close', null)" 
                                type="button" class="close custom-modal--close" 
                                data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h1 class="modal-title" v-if="selectedJob">Add Note </h1>
                        </div>
                        <div class="modal-body mt-15" v-if="addNoteDilog">
                            <form>
                                <div class="row">
                                    <div class="col-sm-12 o-no-padding">
                                        <div class="col-md-5 o-right-no-padding o-calender-area">
                                            <div class="o-calls-table">
                                                <div class="o-calender-details-list">
                                                    <el-form :model="addNoteDialogForm">
                                                        <el-form-item label="Note">
                                                        <el-input v-model="addNoteDialogForm.note" autocomplete="off"></el-input>
                                                        </el-form-item>
                                                    </el-form>
                                                </div>                                       
                                            </div>
                                        </div>                                
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div class="modal-footer text-center">
                                <span slot="footer" class="dialog-footer">
                                <el-button @click="openCloseAddNoteModal('close', null)">Cancel</el-button>
                                <el-button type="primary" @click="performCallouDeclineActions(callData, addNoteDialogForm.note)">{{ action }}</el-button>
                            </span>
                        </div>

                    </div>
                </div>
            </div>
        </modal>

        <modal name="otbConflictPop"  height="auto" :scrollable="false" class="modal-dialog modal-sm modal--custom">
            <div  tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content otb-modal-content">
                        <div class="modal-header text-center">
                            <button 
                                @click="closeOtbConflictPop()" 
                                type="button" 
                                class="close otb-close custom-modal--close otb-modal--close" 
                                data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h1 class="modal-title otb-title">WARNING !</h1>
                        </div>
                        <div class="modal-body">
                                <div class="otb-conflict-body">
                                    This employee is ALREADY CONFIRMED in another client. DO NOT CONFIRM without speaking to the employee first!'
                                    'Confirming this call will automatically notify dispatch in another jurisdiction of a cleared confirmation!
                                </div>   
                        </div>                        

                        <div class="modal-footer text-center">
                            <a 
                                id="btn-bulk-assign-modal" 
                                href="javascript: void(0)" 
                                @click="closeOtbConflictPop()" 
                                class="c-common-btn c-common-btn--small otb-modal-cancel-btn"> 
                                Cancel
                            </a>
                            <a 
                                id="btn-bulk-assign-modal" 
                                href="javascript: void(0)" 
                                @click="proceedWithConflict(selectedPhoneID)" 
                                class="c-common-btn c-common-btn--small otb-modal-proceed-btn">
                                Proceed
                            </a>
                        </div>
                    
                    </div>
                </div>
            </div>
        </modal>
    </div>
    <div v-else-if="!isEmployeeAllowed">
        <NotAllowed />
    </div>

  </div>
</template>
<script>
    import NotAllowed from '@/components/NotAllowed';
    import dateTimeConvert from '../timeConvert&Compare';
    import {
        VueEditor
    } from 'vue2-editor';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../services.js';
    import OpenWindowPanel from './phoneSheet/openWindowPanel.vue';
    import { buildNotifyMessage } from '../utils/notifyStats.js';
    import {
        scroller
    } from 'vue-scrollto/src/scrollTo';
    export default {
        components: {
            VueEditor,
            NotAllowed,
            OpenWindowPanel
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                subDomain: 'getSubdomain',
                jobId: 'selectedJobId',
                userName: "userName",
                userFirstName: "userFirstName",
                userFullName: "userFullName",
                employeeId: 'employeeId',
            }),
            afMetricLabel() {
                const labels = {
                    'emp_seniority': 'Sen',
                    'last_first': 'L,F',
                    'member_seniority': 'MS',
                    'date_of_hire': 'DOH',
                    'random': 'RND',
                };
                return labels[this.autofillMetrics] || '';
            }
        },
        
        data() {
            return {
                isEmployeeAllowed: true,
                displayBatchNotify: false,
                loading:false,
                callData: null,
                addNoteDilog: false,
                addNoteDialogForm: {
                    note: ''
                },
                action: null,
                pass_option:1,
                selectedShortType: 'name',
                phoneSheetList: [],
                afterAPI: false,
                dateWiseCheckField: [],
                emailContent: '',
                sms: "",
                selectedEmpIds: [],
                internetConfirm: '',
                customField1: '',
                customField2: '',
                showCustom: '',
                send_to: 'not_notified_yet',
                call_info: 'after',
                lockNotify: false,
                title: "",
                notifyType:'batch',
                selectedJob:{},
                full_address_map:'',
                job:null,
                polling: null,
                selectConfig:{
                    days:[0, 1, 2, 3, 4, 5],
                    hours:[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
                    mins:[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]
                },
                globalTimeOut:{
                    days:0,
                    hours:0,
                    mins:0
                },
                jobTimeOut:{
                    days:0,
                    hours:0,
                    mins:0
                },
                templateMsgs: [],
                tempTemplates: [],
                tags: [
                    'Please login to Confirm',
                    'TIME CHANGE Please Login',
                    'SHORT NOTICE',
                    'Call Dispatch ASAP',
                    'Work Available',
                    'Please RE-CONFIRM ASAP',
                    'Please login to ConfirmPass or Decline',
                    'Respond within',
                    'This Offer expires within',
                    'Please Confirm or Decline'
                ],
                selectedPhoneID: null,
                disabled: false,
                autofillMetrics: '',
                metrics: [
                    { name: 'Employee Seniority (Ascending)', value: 'emp_seniority' },
                    { name: 'Last Name, First Name', value: 'last_first' },
                    { name: 'Member Seniority', value: 'member_seniority' },
                    { name: 'Date of Hire', value: 'date_of_hire' },
                    { name: 'Random', value: 'random' },
                ],
                autofill_status: 0,
                hasError: false,
                error: {},
            }            
        },
        methods: {
            extractErrorMessage(err, fallback) {
                if (err && err.response && err.response.data && err.response.data.message) {
                    return err.response.data.message;
                }
                if (err && err.response && err.response.data && err.response.data.status_message) {
                    return err.response.data.status_message;
                }
                if (err && err.message) {
                    return err.message;
                }
                return fallback || 'An error occurred';
            },
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    if(phone == ' '||phone==" ") {
                        result = ''
                    }
                    result = phone;
                }
                return result;
            },
            
            getRoundOffSkillSeniority(seniorityVal) {     
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            updateSmsLength() { 
                this.sms = '';              
                this.sms.length = this.getTotalTemplateCharCount();                 
            },
            getTotalTemplateCharCount() {
                if(this.call_info&&this.call_info == 'no') {
                    return 160;
                }
                return 160;
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            getMapUrl(){
				return dateTimeConvert.getMapUrl(this.full_address_map);
			},     

            addTemplateMsgs(msg){
                this.sms=msg;
            },

            openMap(){
                this.selectedJob=this.job;
                let venue =this.selectedJob.venue;
                if(venue && venue.addresses && venue.addresses.length){
                    this.full_address_map =venue.name + ", " 
                    +venue.addresses[0].address + ", " 
                    +venue.addresses[0].municipality +", "
                    +venue.addresses[0].postcode +", " 
                    +venue.addresses[0].state_province 
                    +", "+ venue.addresses[0].country;
                }
                this.$modal.show("calender-details");
            },
            formatPhoneNumber(phoneNumberString) {
              var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
              var match = cleaned.match(/^(\d{3})(\d{3})(\d+)$/)
              if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3]
              }
              return null
            },

            setGlobalTimeout(time){
                var hours=time.split(':')[0];
                var minutes= time.split(':')[1];
                this.globalTimeOut.days=Math.floor(hours/24);
                this.globalTimeOut.hours=Math.floor(hours%24);
                this.globalTimeOut.mins=Math.floor(minutes);
            },

            setJobTimeout(time){
                var hours=time.split(':')[0];
                var minutes= time.split(':')[1];
                this.jobTimeOut.days=Math.floor(hours/24);
                this.jobTimeOut.hours=Math.floor(hours%24);
                this.jobTimeOut.mins=Math.floor(minutes);
            },

            getJobTimeOut(){
                var hours = (this.jobTimeOut.days*24)+this.jobTimeOut.hours;
                var mins =this.jobTimeOut.mins;
                return Math.round(hours)+':'+Math.round(mins);
            },

            onChangeJobTimeOut(){
                let timeOut=this.getJobTimeOut();
                service.post('job/updatejobTimeOut', {
                    'job_id': atob(this.$route.params.jobId),
                    'timeout':timeOut
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    // console.log('success');
                }).catch((err) => {
                    console.log(err);
                });
            },

            closeMap() {
                this.$modal.hide("calender-details");
            },

            getCustomField(data) {
                var customFld = JSON.parse(data);
                let re = -1;
                let re2 = -1;
                if(customFld && customFld.value && (typeof customFld.value == 'string'))
                {
                    re = customFld.value.search('{\"name\":');
                    let inner = "";
                    if(re>=0) {
                        inner = JSON.parse(customFld.value);
                        if(inner&&inner != ''&&inner.value && (typeof inner.value == 'string'))
                            re2 = inner.value.search('{\"name\":')
                        if(inner.value == "{}" || inner.value == "NULL" || inner.value == "null" || inner.value == "Null" || re2>=0)
                            return '--';
                        return inner.value;
                    }else
                    return customFld&&customFld.value && 
                    customFld.value !='{}' && 
                    customFld.value !='NULL' && 
                    customFld.value!='Null' && 
                    customFld.value != 'null' ? 
                    customFld.value : 
                    '--';  
                }
                return "--"; 
            },

            IsJsonString(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            },

            backToJobDetails(){
                this.$router.push({
                    path: `/jobDetails/`+this.$route.params.jobId
                });
            },

            gotoJobAttendance() {
                this.$router.push({
                    path: `/jobAttendance/`+this.$route.params.jobId
                });
            },

            // #1562: Wishlist Summary + WishList 30 Day report buttons (mirror viewCalls #1561).
            // Self-contained (local rdlxUrl, no new data prop). loadWishlistSummaryReportJson =
            // plain summary (employeeWishlistSummaryJsonPayload/<jobuuid>); the 30-day variant
            // hits employeeWishlistSummary30DayJsonPayload. Templates already exist.
            async getWishlistSummaryTemplateUrl(thirtyDay) {
                let rdlxUrl = null;
                const headers = {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                };
                if (thirtyDay) {
                    await service.get('client/getEmployeeWishlistSummary30DayReportUrl', headers)
                        .then((res) => { if (res.data && res.data.result && res.data.result != '') rdlxUrl = res.data.result; })
                        .catch((err) => { console.log(err); });
                }
                if (!rdlxUrl) {
                    await service.get('client/getEmployeeWishlistSummaryReportUrl', headers)
                        .then((res) => { if (res.data && res.data.result && res.data.result != '') rdlxUrl = res.data.result; })
                        .catch((err) => { console.log(err); });
                }
                return rdlxUrl;
            },
            openWishlistReport(payloadEndpoint, thirtyDay) {
                this.loading = true;
                service.get(payloadEndpoint, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then(async (res) => {
                    const rdlxUrl = await this.getWishlistSummaryTemplateUrl(thirtyDay);
                    this.loading = false;
                    let data_source = res.data.result && res.data.result != '' ? res.data.result : null;
                    if (rdlxUrl && data_source) {
                        let redirectUrl = dateTimeConvert.getEmployeeReportUrl('jobReports/', rdlxUrl, data_source);
                        let wishlistPopup = window.open(redirectUrl, 'wishlistSummaryPopup', 'width=1200,height=800,scrollbars=yes,resizable=yes');
                        if (!wishlistPopup) {
                            // popup blocked — fall back to a new tab
                            window.open(redirectUrl, "_blank");
                        }
                    } else {
                        this.$notify({
                            title: 'Error',
                            message: 'Something went wrong!',
                            type: 'error'
                        });
                    }
                }).catch((err) => {
                    this.loading = false;
                    console.log(err);
                });
            },
            loadWishlistSummaryReportJson() {
                this.openWishlistReport('client/employeeWishlistSummaryJsonPayload/' + atob(this.$route.params.jobId), false);
            },
            loadWishlistSummary30DayReportJson() {
                this.openWishlistReport('client/employeeWishlistSummary30DayJsonPayload', true);
            },

            onSelectScrollTo(e) {
                const firstScrollTo = scroller();
                firstScrollTo(e.target.value, 200, {
                    offset: -100
                });
            },

            sortPhoneSheet() {
                let self = this;
                switch (this.selectedShortType) {
                    case 'name':
                        for (let key in this.phoneSheetList) {
                            this.phoneSheetList[key].sort(function(a, b) {
                                if (a.employee.employable.first_name < b.employee.employable.first_name) return -1;
                                if (a.employee.employable.first_name > b.employee.employable.first_name) return 1;
                                return 0;
                            });
                        }
                        break;
                    case 'seniority':
                        for (let key in this.phoneSheetList) {
                            this.phoneSheetList[key].sort(function(a, b) {
                                if(a.employee.seniority == null)
                                    a.employee.seniority = 0;
                                if(b.employee.seniority==null)
                                    b.employee.seniority = 0;
                                if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)){
                                    return -1;
                                } 
                                if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)){
                                    return 1; 
                                } 
                                return 0;
                            });
                        }
                        break;
                    case 'skill':
                        for (let key in this.phoneSheetList) {
                            this.phoneSheetList[key].sort(function(a, b) {
                                if (a.skill.name < b.skill.name) return -1;
                                if (a.skill.name > b.skill.name) return 1;
                                return 0;
                            });
                        }
                        break;
                    case 'fname_asc':
                        for (let key in this.phoneSheetList) {
                            this.phoneSheetList[key].sort(function(a, b) {
                                if (a.employee.employable.first_name < b.employee.employable.first_name) return -1;
                                if (a.employee.employable.first_name > b.employee.employable.first_name) return 1;
                                return 0;
                            });
                        }
                        break;
                    case 'lname_asc':
                        for (let key in this.phoneSheetList) {
                            this.phoneSheetList[key].sort(function(a, b) {
                                if (a.employee.employable.last_name < b.employee.employable.last_name) return -1;
                                if (a.employee.employable.last_name > b.employee.employable.last_name) return 1;
                                return 0;
                            });
                        }
                        break;
                    default:
                        //console.log("default case..");
                }
            },

            onSelectAction(index) {
                this.$confirm('Are you sure ?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    let callIds = this.dateWiseCheckField[index].callUnderDate;
                    switch (this.dateWiseCheckField[index].selectedBulkAction) {
                        case 'Confirm':
                            if (this.dateWiseCheckField[index].callUnderDate.length != 0) {
                                this.$Progress.start();
                                service.post('call/' + callIds[0] + '/bulkConfirm', {
                                    'call_ids': JSON.stringify(callIds),
                                    'user_id': this.userID
                                }, {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                }).
                                then((res) => {
                                    this.$Progress.finish();

                                    this.$notify({
                                        title: 'Success',
                                        message: 'Calls confirmed successfully.',
                                        type: 'success'
                                    });
                                    this.getPhoneSheetList();
                                }).catch((err) => {
                                    console.log(err);
                                    this.$Progress.finish();
                                    this.$notify.error({
                                        title: 'Error',
                                        message: this.extractErrorMessage(err, 'Confirm failed')
                                    });
                                });
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Please select at least one call.'
                                });
                            }
                            break;
                        case 'Pass':
                            if (this.dateWiseCheckField[index].callUnderDate.length != 0) {
                                this.$Progress.start();
                                service.post('call/' + callIds[0] + '/bulkPassed', {
                                    'call_ids': JSON.stringify(callIds),
                                    'user_id': this.userID,
                                }, {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                }).
                                then((res) => {
                                    this.$Progress.finish();
                                    this.$notify({
                                        title: 'Success',
                                        message: 'Calls passed successfully.',
                                        type: 'success'
                                    });
                                    this.getPhoneSheetList();
                                }).catch((err) => {
                                    console.log(err);
                                    this.$Progress.finish();
                                    this.$notify.error({
                                        title: 'Error',
                                        message: this.extractErrorMessage(err, 'Pass failed')
                                    });
                                });
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Please select at least one call.'
                                });
                            }
                            break;
                        case 'Decline':
                            if (this.dateWiseCheckField[index].callUnderDate.length != 0) {
                                this.$confirm('Do you want to decline?', 'Warning', {
                                    confirmButtonText: 'OK',
                                    cancelButtonText: 'Cancel',
                                    type: 'warning'
                                }).then(() => {
                                    this.$Progress.start();
                                    service.post('call/' + callIds[0] + '/bulkDecline', {
                                        'call_ids': JSON.stringify(callIds),
                                        'user_id': this.userID,
                                    }, {
                                        'Authorization': this.userToken,
                                        'cs3-context-role': this.userRole,
                                        'cs3-context-clientId': this.userClientID,
                                    }).
                                    then((res) => {
                                        this.$Progress.finish();
                                        this.$notify({
                                            title: 'Success',
                                            message: 'Calls declined successfully.',
                                            type: 'success'
                                        });
                                        this.getPhoneSheetList();
                                    }).catch((err) => {
                                        console.log(err);
                                        this.$Progress.finish();
                                        this.$notify.error({
                                            title: 'Error',
                                            message: this.extractErrorMessage(err, 'Decline failed')
                                        });
                                    });
                                }).catch(() => {
                                    this.$message({
                                        type: 'info',
                                        message: 'Declined canceled'
                                    });
                                });
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Please select at least one call.'
                                });
                            }
                            break;
                        case 'Clear':
                            if (this.dateWiseCheckField[index].callUnderDate.length != 0) {
                                this.$Progress.start();
                                service.post('call/' + callIds[0] + '/bulkClearAssignment', {
                                    'call_ids': JSON.stringify(callIds),
                                    'user_id': this.userID,
                                }, {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                }).
                                then((res) => {
                                    this.$Progress.finish();
                                    this.$notify({
                                        title: 'Success',
                                        message: 'Calls cleared successfully.',
                                        type: 'success'
                                    });
                                    this.getPhoneSheetList();
                                }).catch((err) => {
                                    console.log(err);
                                    this.$Progress.finish();
                                    this.$notify.error({
                                        title: 'Error',
                                        message: this.extractErrorMessage(err, 'Clear failed')
                                    });
                                });
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Please select at least one call.'
                                });
                            }
                            break;
                        case 'Mark':
                            if (this.dateWiseCheckField[index].callUnderDate.length != 0) {
                                this.$Progress.start();
                                service.post('call/' + callIds[0] + '/bulkMark', {
                                    'call_ids': JSON.stringify(callIds),
                                    'user_id': this.userID,
                                }, {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                }).
                                then((res) => {
                                    this.$Progress.finish();
                                    this.$notify({
                                        title: 'Success',
                                        message: 'Calls Marked successfully.',
                                        type: 'success'
                                    });
                                    this.getPhoneSheetList();
                                }).catch((err) => {
                                    console.log(err);
                                    this.$Progress.finish();
                                    this.$notify.error({
                                        title: 'Error',
                                        message: this.extractErrorMessage(err, 'Mark failed')
                                    });
                                });
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Please select at least one call.'
                                });
                            }
                            break;
                        case 'Notify':
                            if (this.dateWiseCheckField[index].callUnderDate.length != 0) {
                                this.$modal.show('batch-notify');
                                this.notifyType='selected';
                                this.send_to= JSON.stringify(callIds);
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Please select at least one call.'
                                });
                            }
                            break;
                        default:
                            //console.log("default case..");
                    }
                    setTimeout(() => {
                        this.dateWiseCheckField[index].selectedBulkAction='';
                        this.dateWiseCheckField[index].dateCheck=false;
                    }, 1500);
                }).catch(() => {
                    this.dateWiseCheckField[index].selectedBulkAction='';
                    this.dateWiseCheckField[index].dateCheck=false;
                });
            },

            onUpdateSubInput(index) {
                if (this.dateWiseCheckField[index].callsLength != this.dateWiseCheckField[index].callUnderDate.length) {
                    this.dateWiseCheckField[index].dateCheck = false;
                }
            },

            updateSubSelection(index, calls) {
                if (this.dateWiseCheckField[index].dateCheck) {
                    for (let i = 0; i < calls.length; i++) {
                        this.dateWiseCheckField[index].callUnderDate.push(calls[i].id);
                    }
                } else {
                    this.dateWiseCheckField[index].callUnderDate = [];
                }
            },

            goToViewCalls() {
                this.$router.push({
                    path: '/viewCalls/' + this.$route.params.jobId
                });
            },

            goToPhoneSheet() {
                this.$router.push({
                    path: '/phoneSheet/' + this.$route.params.jobId
                });
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },

            getDate(dateTime) {
                return dateTimeConvert.localDateFull(dateTime);
            },

            getGlobalDate(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },

            getDateForStatus(dateTime) {
                return dateTimeConvert.utcTimeToUserTime(dateTime);
            },

            getPhoneSheetList() {
                this.$Progress.start();
                this.loading=true;
                service.get('job/' + atob(this.$route.params.jobId) + '/phoneSheet', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'userId': this.userID
                    })
                    .then((res) => {
                        this.phoneSheetList = res.data.result;
                        this.$Progress.finish();
                        this.afterAPI = true;
                        this.dateWiseCheckField=[];
                        for (let key in this.phoneSheetList) {
                            let tempData = {
                                dateCheck: false,
                                callUnderDate: [],
                                selectedBulkAction: '',
                                callsLength: this.phoneSheetList[key].length,
                            }
                            this.dateWiseCheckField.push(tempData);
                        }
                        this.sortPhoneSheet();
                        this.loading=false;
                    }).catch((err) => {
                        console.log(err);
                        this.afterAPI = true;
                        this.loading=false;
                        if(err.response&&err.response.status&&err.response.status==403) {
                            this.isEmployeeAllowed = false;
                            this.$notify({
                                title: 'Important message',
                                message: "You don't have Access!",
                                type: 'error'
                            });
                            this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                        }
                    });
            },

            confirmCall(callId) {
                this.$confirm('Are you sure you would like to confirm this Call?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$Progress.start();
                    service.put('call/' + callId + '/confirm', {
                        'user_id': this.userID,
                        'logged_in_employee_id': this.employeeId,
                        'page': 'phonesheet'
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();

                        this.$notify({
                            title: 'Success',
                            message: 'Call confirmed successfully.',
                            type: 'success'
                        });
                        this.getPhoneSheetList();
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                        this.$notify.error({
                            title: 'Error',
                            message: this.extractErrorMessage(err, 'Confirm failed')
                        });
                    });
                }).catch(() => {
                    
                });
            },

            passCall(callId) {
                this.$confirm('Are you sure you would like to pass this Call?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.put('call/' + callId + '/pass', {
                        'user_id': this.userID,
                        'logged_in_employee_id': this.employeeId,
                        'page': 'phonesheet'
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$notify({
                            title: 'Success',
                            message: 'Call passed successfully.',
                            type: 'success'
                        });
                        this.getPhoneSheetList();
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                        this.$notify.error({
                            title: 'Error',
                            message: this.extractErrorMessage(err, 'Pass failed')
                        });
                    });
                }).catch(() => {

                });
            },

            declineCall(call) {
                this.action = 'Decline'                           
                this.$confirm('Are you sure you would like to decline this Call? ', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.addNoteDilog = true;
                    this.openCloseAddNoteModal('open', call);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Declined canceled'
                    });
                });
            },

            openCloseAddNoteModal(type, call){
                this.addNoteDilog = true;
                this.callData = call;
                if(type == 'open'){
                    this.addNoteDilog = true;
                    this.$modal.show("add-note-callout-decline");
                }else{
                    this.addNoteDilog = false;
                    this.$modal.hide("add-note-callout-decline");
                }
            },

            async openAddNoteDecline(call,value) {
                this.declined = true;
                var activityID = {
                    "uploader_id": this.userID,
                    "uploaded_by": this.userFullName,
                };
                activityID = JSON.stringify(activityID);
                await service.put('call/' + call.id + '/decline', {
                        'user_id': this.userID,
                        'logged_in_employee_id': this.employeeId,
                        'page': 'phonesheet',
                        'api_section':'phonesheet',
                        'activity': activityID,
                        'note_content': value,
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).then((res) => {
                        this.declined = false;
                        this.$Progress.finish();
                        this.$notify({
                            title: 'Success',
                            message: 'Call declined successfully.',
                            type: 'success'
                        });
                        this.getPhoneSheetList();
                    }).catch((err) => {
                        this.declined = false;
                        console.log(err);
                        this.$Progress.finish();
                        this.$notify.error({
                            title: 'Error',
                            message: this.extractErrorMessage(err, 'Decline failed')
                        });
                    });
            },

            async performCallouDeclineActions(call,value) {
                if(this.action == 'Decline') {
                    await this.openAddNotePromptDecline(call,value);
                }
            },

            async openAddNotePromptDecline(call,value) {
                 var activityID = {
                    "uploader_id": this.userID,
                    "uploaded_by": this.userFullName,
                };
                activityID = JSON.stringify(activityID);
                service.put('call/' + call.id + '/decline', {
                        user_id: this.userID,//this.userId
                        logged_in_employee_id: this.employeeId,
                        page: 'phonesheet',
                        'activity': activityID,
                        'note_content': value,
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.addNoteDilog = false;
                        this.$modal.hide("add-note-callout-decline");
                        this.$notify({
                            title: 'Success',
                            message: 'Call declined successfully.',
                            type: 'success'
                        });
                        this.getPhoneSheetList();
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                        this.$notify.error({
                            title: 'Error',
                            message: this.extractErrorMessage(err, 'Decline failed')
                        });
                    });
            },

            clearAssign(callId) {
                this.$confirm('Are you sure you would like to clear this Call? ', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.del('call/' + callId + '/assign', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'userId': this.userID,
                        'api_section':'phonesheet'
                    }).
                    then((res) => {
                        this.$notify({
                            title: 'Success',
                            message: 'Call cleared successfully.',
                            type: 'success'
                        });
                        this.getPhoneSheetList();
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                            title: 'Error',
                            message: this.extractErrorMessage(err, 'Clear assignment failed')
                        });
                    });
                }).catch(() => {

                });
            },

            markedCall(callId) {
                service.put('call/' + callId + '/markcalled', {
                    'user_id': this.userID
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                    this.$Progress.finish();
                    this.$notify({
                        title: 'Success',
                        message: 'Call marked successfully.',
                        type: 'success'
                    });
                    this.getPhoneSheetList();
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.$notify.error({
                        title: 'Error',
                        message: this.extractErrorMessage(err, 'Mark call failed')
                    });
                });
            },

            gotoActionlog() {
                this.$store.dispatch('setActionTypeForLog', 'clientAction');
                this.$router.push({
                    path: `/actionlog/`+this.$route.params.jobId
                });
            },

            gotoNotifyLog() {
                this.$store.dispatch('setNotificationType', 'clientAction');
                this.$router.push({
                    path: `/notifyLog/`+this.$route.params.jobId
                });
            },

            addBatchNotify(data) {
                let self = this;
                self.notifyType=data;
                if(self.notifyType!='batch'){
                    self.send_to=data;
                }
                self.$modal.show('batch-notify');
            },

            selectedNotify(){
                self.$modal.show('batch-notify');
            },

            sendNotify() {
                if (this.sms == '') {
                    this.$notify.error({
                        title: 'Error',
                        message: 'You cannot send a blank message'
                    });
                } else if(this.notifyType == 'batch') {
                    this.validateContent('sms', this.sms);
                    if (this.hasValidationErrors()) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before saving.'}
                        ); 
                        return; // Stop the save process
                    }

                    if(this.send_to == 'all') {
                        this.$confirm('Are you Sure? Notify to All users on this Job!', 'Warning', {
                            confirmButtonText: 'OK',
                            cancelButtonText: 'Cancel',
                            type: 'warning'
                        }).then(() => {
                            this.sendBatchNotify();
                        }).catch((err) => {
                            console.log(err);
                            this.$Progress.finish();
                        });

                    } else {
                        this.sendBatchNotify();    
                    }                
                } else if(this.notifyType=='selected'){
                    this.validateContent('sms', this.sms);
                    if (this.hasValidationErrors()) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before saving.'}
                        ); 
                        return; // Stop the save process
                    }
                    this.lockNotify = true;
                    service.post('job/selectedNotify', {
                        'message': this.sms,
                        'call_ids': this.send_to,
                        'call_info': this.call_info,
                        'user_id': this.userID
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.lockNotify = false;
                        this.$store.dispatch('setHasPendingBatch', true);
                        this.$notify({
                            title: 'Success',
                            message: buildNotifyMessage(res),
                            type: 'success'
                        });
                        this.getPhoneSheetList();
                        this.closeBatchNotify();

                    }).catch((err) => {
                        this.lockNotify = false;
                        var errMsg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Notify failed';
                        this.$notify.error({
                            title: 'Error',
                            message: errMsg
                        });
                        this.closeBatchNotify();

                    });
                } else{
                    this.validateContent('sms', this.sms);
                    if (this.hasValidationErrors()) {
                        this.$notify.error({
                            title: 'Error', 
                            message:'Please fix validation errors before saving.'}
                        ); 
                        return; // Stop the save process
                    }
                    this.lockNotify = true;
                    service.post('job/individualNotify', {
                        'message': this.sms,
                        'call_id': this.send_to,
                        'call_info': this.call_info,
                        'user_id': this.userID
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.lockNotify = false;
                        this.$store.dispatch('setHasPendingBatch', true);
                        this.$notify({
                            title: 'Success',
                            message: res.data.status_message,
                            type: 'success'
                        });
                        this.getPhoneSheetList();
                        this.closeBatchNotify();

                    }).catch((err) => {
                        this.lockNotify = false;
                        this.$notify.error({
                            title: 'Error',
                            message: this.extractErrorMessage(err, 'Notify failed')
                        });
                        this.closeBatchNotify();
                    });
                }
            },

            sendBatchNotify() {
                this.lockNotify = true;
                service.post('job/' + atob(this.$route.params.jobId) + '/batchNotify', {
                    'send_to': this.send_to,
                    'call_info': this.call_info,
                    'message': this.sms,
                    'user_id': this.userID
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.lockNotify = false;
                    this.$store.dispatch('setHasPendingBatch', true);
                    this.$notify({
                        title: 'Queued',
                        message: buildNotifyMessage(res),
                        type: 'success'
                    });
                    this.closeBatchNotify();

                }).catch((err) => {
                    this.lockNotify = false;
                    var errMsg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : 'Batch notify failed';
                    this.$notify.error({
                        title: 'Error',
                        message: errMsg
                    });
                    this.closeBatchNotify();
                });
            },

            closeBatchNotify() {
                this.send_to = 'not_notified_yet';
                this.sms = '';
                this.call_info = 'after',
                this.$modal.hide('batch-notify');
            },

            async jobDetails() {
                this.$Progress.start();
                await service.get('job/' + atob(this.$route.params.jobId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.title = res.data.result.title;
                    this.job=res.data.result;
                    this.autofill_status = parseInt(this.job.af_onoff) ? 1 : 0;
                    this.autofillMetrics = this.job.af_metric ? this.job.af_metric : "";
                    this.setJobTimeout(this.job.timeout);
                    this.$Progress.finish();
                }).catch((err) => {
                    console.log(err);
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
            },

            pollData () {
                clearInterval(this.polling);
                this.polling = setInterval(() => {
                    this.getPhoneSheetList();
                }, 60000);
            },
            getClient(){
                service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    this.displayBatchNotify = res.data.result["batch_notify_flag"];
                    this.customField1 = res.data.result["custom_field_1"];
                    this.customField2 = res.data.result["custom_field_2"];
                    this.showCustom = res.data.result.call_sheet_title;
                    this.pass_option= res.data.result.pass_option;
                    this.selectedShortType=res.data.result.default_phonesheet_sort;
                    this.setGlobalTimeout(res.data.result.phonesheet_ts);
                    if(res.data.result.notify_templates){
                        this.templateMsgs = JSON.parse(res.data.result.notify_templates)
                    }else {
                        this.templateMsgs = this.tags
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            
            checkOtherBookingConflict(phone) {
                let status = false;
                if(phone.mua_booking_conflict&&phone.mua_booking_conflict.length) {
                    this.selectedPhoneID = phone.id;
                    this.$modal.show("otbConflictPop");
                } else {
                    this.selectedPhoneID = null;
                    this.confirmCall(phone.id);
                }
            },
            closeOtbConflictPop() {                
                this.$modal.hide("otbConflictPop");
            },
            proceedWithConflict(phone_id){
                this.confirmCall(phone_id);
                this.$modal.hide("otbConflictPop");
            },
            onChangeAutofillMetrics() {
                const body = {
                    job_id: atob(this.$route.params.jobId),
                    af_metric: this.autofillMetrics
                }
                const headers = {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userId': this.userID,
                }
                service.post('job/updateJobAutoFillMetrics', body, headers).
                then((res) => {
                    this.$notify({
                        title: 'Success',
                        message: 'Autofill Metric updated successfully.',
                        type: 'success'
                    });
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        type: 'error',
                        message: 'Something went wrong.',
                        title: 'Error'
                    });
                });
            },
            onChangeAutofillStatus() {
                const body = {
                    job_id: atob(this.$route.params.jobId),
                    af_onoff: parseInt(this.autofill_status)
                }
                const headers = {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userId': this.userID,
                }
                service.post('job/updateJobAutoFill', body, headers).
                then((res) => {
                    this.$notify({
                        title: 'Success',
                        message: 'Autofill status updated successfully.',
                        type: 'success'
                    });
                    this.getPhoneSheetList();
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        type: 'error',
                        message: 'Something went wrong.',
                        title: 'Error'
                    });
                });

            },
            validateContent(fieldName, value) {

                console.log(fieldName, value);
                // Initialize error object if it doesn't exist
                if (!this.error) {
                    this.$set(this, 'error', {});
                }
                
                // Reset error state for this field
                this.$set(this.error, fieldName, {
                    hasError: false,
                    message: ''
                });
                
                // Get plain text content (strip HTML tags)
                const plainText = this.getPlainText(value);
                
                // Only validate if there's content
                if (plainText.trim().length > 0) {
                    if (this.containsInvalidContent(plainText)) {
                        this.$set(this.error, fieldName, {
                            hasError: true,
                            message: 'Content contains invalid text. Please review and correct.'
                        });
                    }
                }
            },
    
            getPlainText(html) {
                // Remove HTML tags and get plain text
                const div = document.createElement('div');
                div.innerHTML = html;
                return div.textContent || div.innerText || '';
            },
    
            containsInvalidContent(text) {
                                
                // Example 1: Check for script tags or malicious content
                const scriptPattern = /<script|javascript:|onerror=|onclick=/i;
                
                // Example 2: Check for excessive special characters
                const excessiveSpecialChars = /[.?!,#$^&*()@%|"':;<>]{3,}/;
                
                // Example 3: Check for spam-like patterns (multiple repeated characters)
                const spamPattern = /(.)\1{3,}/;
                
                // Example 4: Check for invalid URLs or suspicious links
                const suspiciousUrl = /bit\.ly|tinyurl|goo\.gl/i;
                
                // Return true if any invalid pattern is found
                return scriptPattern.test(text) || 
                excessiveSpecialChars.test(text) || 
                spamPattern.test(text) ||
                suspiciousUrl.test(text);
            },

            hasValidationErrors() {
                // Check if any field has errors
                if (!this.error) return false;
                
                return Object.values(this.error).some(error => error.hasError === true);
            },
        },
        async created() {
            // await this.jobDetails();
            // if(this.job) {
            //     this.getPhoneSheetList();
            //     this.getClient();
            //     document.title =  `${this.job.job_number}#${this.job.title}`;
            //     this.autofill_status = this.job.autofill ? 1 : 0;
            // }
        },
        async mounted(){
            await this.jobDetails();
            if(this.job) {
                this.autofill_status = parseInt(this.job.af_onoff) ? 1 : 0;
                this.autofillMetrics = this.job.af_metric ? this.job.af_metric : "";
                this.getPhoneSheetList();
                this.getClient();
                document.title =  `${this.job.job_number}#${this.job.title}`;
            }
            document.onmousemove = this.pollData;
            document.onclick = this.pollData;     // touchpad clicks
            document.onscroll = this.pollData;    // scrolling with arrow keys
            document.onkeydown = this.pollData;
        },

        beforeDestroy() {
            document.onmousemove = null;
            document.onclick = null;     // touchpad clicks
            document.onscroll = null;   // scrolling with arrow keys
            document.onkeydown = null;
            clearInterval(this.polling);
        }
    }

</script>
<style scoped>
.ml-auto {
    margin-left: auto!important;
}
.w-75 {
    width: 75%;
}
.w-50 {
    width: 50%;
}
.form-group { position: relative; }
.err-msg {
    margin: 2px;
    color: red;
    display: block;
    margin-top: 4px;
    /* ensure it's not absolutely positioned */
    position: static;
}
.margin-10{
    margin-top: 10px;
}
.phone-number-display{
    width: 100%;
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
.otb-flag {
    background-color: #FB8B03;
    color: #000000;
    font-size: 12px;
    font-weight: 500;
    padding: 5px;
    margin: 2px;
    height:15px;
    width:20px;
}
.otb-modal-content {
    border-radius: 3px !important;
    padding: 0px!important;
    background-color: #ffffff;
    border: 2px solid #000000!important;
}

.otb-title {
    padding: 5px;
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    background-color: #F67801;
    border-bottom: 2px solid #000000;
}

.otb-close {
    text-shadow: 0 0 0 #000000!important;
    font-size: 15px;
}

.otb-modal--close {
    opacity: 1;
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 20px;
    width: 20px;
    height: 20px;
    background-color: #F67801!important;
    color: #000000!important;
    padding: 0 !important;
    text-shadow: #000000!important;
    margin-top: 0;
}

.otb-modal-cancel-btn {
    background-color: #F67801;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}
.otb-modal-proceed-btn {
    background-color: #17A068;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}
.otb-conflict-body {
    line-height: 1.5;
    font-size: 15px;
    font-weight: 500;
    padding: 10px 10px 0;
}
.mt-15{
    margin-top: 15px;
}
.o-red-icon i {
    font-size: 25px;
}

.time-out-part {
    width: 45px;
    display: inline;
    height: 30px;
}
    
.phone-sheet-call-timeout {
    text-align: center;
    border-radius: 5px;
    border: #232324 1px solid;
    appearance: none;
    -ms-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    height: 32px;
    width: 12%;
    padding: 5px;
    color: #2c2b2b;
    font-size: 14px;
    outline: none;
    background: white;
    margin: 1px 1px 5px;
    /* -webkit-appearance: none; */
}
.phone-sheet-call-timeout-disable {
    text-align: center;
    border-radius: 5px;
    border: #b8b8b8 1px solid;
    appearance: none;
    -ms-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    height: 32px;
    width: 12%;
    padding: 5px;
    color: #686666;
    font-size: 14px;
    outline: none;
    background: #f4f7f8;
    margin: 1px 1px 5px;
    /* -webkit-appearance: none; */
}

.phonesheet-time-out{
    padding:3px;
}
.phonesheet-time-out select{
    width:45px;
    display:inline;
    height: 32px;
}
.call-deactive{
      background-color: #ffffff;
      /* color: #fff; */
      border-radius: 5px;
      border: 1px solid #bfbdbd;
}
.ps-message-suggestions{
    font-size: 12px;
    padding: 2px;
    background-color: #55a2a2;
    color: white;
    border-radius: 4px;
    line-height: 2;
    margin: 2px;
    word-break: keep-all;
    word-wrap: keep;
    /* display:inline-block; */
}

</style>
